import { mapSales, mapSaleProducts } from "@/api/mapping/sale";

export default function ($api) {
    return {
        getAll(query = "") {
            return $api.get(`api/sale/all${query}`).then(mapSales);
        },
        getProducts({ id, query = "" }) {
            return $api.get(`api/sale/${id}/products${query}`).then(mapSaleProducts);
        },
        getPercentage(id) {
            return $api.get(`api/sale/${id}/percentage`);
        },
    };
}
